import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { class: "text-h4 font-weight-medium" }
const _hoisted_4 = { class: "mt-2" }

import '@/styles/global.scss'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

const router = useRouter()


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-warning" }),
            _cache[2] || (_cache[2] = _createTextVNode(" " + _toDisplayString('Page Not Found'), -1))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-caption" }, _toDisplayString('The page you are looking for does not exist or has been moved.'), -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/'))),
              variant: "tonal"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-home",
                  class: "mr-1"
                }),
                _cache[3] || (_cache[3] = _createTextVNode(" Go to Homepage ", -1))
              ]),
              _: 1,
              __: [3]
            }),
            _createVNode(_component_v_btn, {
              class: "ml-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).back())),
              variant: "tonal",
              color: "tertiary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-arrow-left",
                  class: "mr-1"
                }),
                _cache[4] || (_cache[4] = _createTextVNode(" Go Back ", -1))
              ]),
              _: 1,
              __: [4]
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})